import AutoQuery from 'servicestack/auto-query/auto-query'
import ServiceBus from 'servicestack/service-bus'
import BasicController from 'servicestack/basic.controller'
import $session from 'servicestack/session'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import templateUrl from 'emun.customer/contact-prompt.htm'
import ContactPromptController from 'emun.customer/contact-prompt.controller'


const ContactPromptFactory= {
    open(options) {
        return modals.open(angular.extend({
            templateUrl,
            resolve: {
                options: () => options
            },
            controller: ContactPromptController,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};

function ContactPromptDirective($window, $parse, $session) {
    // Introduce custom elements for IE8
    $window.document.createElement('contact-prompt');
    return {
        scope: false,
        link: function (scope, element, attr) {
            var onContactCreated = attr.onContactCreated || attr.onContactSaved;

            var $targets = (attr.contactPromptClickSelector ? element.find(attr.contactPromptClickSelector) : element);
            $targets.on('click', e => {
                var model = scope.$eval(attr.contactPrompt || attr.ngModel || attr.customer || attr.contact) || {
                    customer: attr.customer,
                    contact: attr.contact
                };
                if (!model.contact) {
                    var date = new Date();
                    model.contact = {
                        retailerId: model.customer.id,
                        createdBy: $session.userAuthName,
                        username: $session.userAuthName
                    }
                }
                ContactPromptFactory.open({ title: attr.title, scope, attr, element, $targets, model }).then(
                    (saved) => {
                        if (attr.onContactSaved) {
                            $parse(attr.onContactSaved)(scope, { $saved: saved })
                        }
                    }, () => {
                        if (attr.onDismissed) {
                            $parse(attr.onDismissed)(scope, {})
                        }
                    });
            });
        }
    }
};

export default ContactPromptDirective;